var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from '@web/components/layout/Button';
import Modal from '@web/components/layout/Modal';
import { EditOrgUnitsManager } from '@web/components/Settings/Members/UsersSection/EditUserModal/EditOrgUnitsManager';
import { Avatar } from '@web/components/ui/Avatar';
import { Select } from '@web/components/ui/Form/Select';
import { IS_DEMO } from '@web/config';
import { useToast } from '@web/hocs/useToast';
import { trpc } from '@web/lib/trpc';
import { orgUnitsAndUsersHelpUrl } from '@web/router/urls';
import { UserRoles } from '@workalizer/shared';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
var updateUserRole = function (currentRole, newRole, userId, updateUserRoleMutation) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (currentRole === newRole) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, updateUserRoleMutation.mutateAsync({
                        userId: userId,
                        role: newRole
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var updateUserOrgUnits = function (_a) {
    var currentUserOrgUnits = _a.currentUserOrgUnits, newUserOrgUnits = _a.newUserOrgUnits, role = _a.role, updateUserOrgUnitsMutation = _a.updateUserOrgUnitsMutation;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, deletedUserOrgUnitsIds, deletedUserOrgUnitsIdsManager, addedUserOrgUnitsManager;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = role;
                    switch (_b) {
                        case UserRoles.ADMIN: return [3 /*break*/, 1];
                        case UserRoles.USER: return [3 /*break*/, 1];
                        case UserRoles.MANAGER: return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 5];
                case 1:
                    deletedUserOrgUnitsIds = currentUserOrgUnits
                        .filter(function (orgUnit) { return !orgUnit.isInGoogle; })
                        .map(function (orgUnit) { return orgUnit.id; });
                    return [4 /*yield*/, updateUserOrgUnitsMutation.mutateAsync({
                            deletedUserOrgUnitsIds: deletedUserOrgUnitsIds
                        })];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 6];
                case 3:
                    deletedUserOrgUnitsIdsManager = currentUserOrgUnits
                        .filter(function (orgUnit) {
                        return !orgUnit.isInGoogle &&
                            !newUserOrgUnits.some(function (newOrgUnit) { return newOrgUnit.orgUnit.id === orgUnit.orgUnit.id; });
                    })
                        .map(function (orgUnit) { return orgUnit.id; });
                    addedUserOrgUnitsManager = newUserOrgUnits
                        .filter(function (newOrgUnit) {
                        return !currentUserOrgUnits.some(function (orgUnit) { return orgUnit.id === newOrgUnit.id; });
                    })
                        .map(function (orgUnit) { return ({
                        orgUnitId: orgUnit.orgUnitId,
                        userId: orgUnit.userId
                    }); });
                    return [4 /*yield*/, updateUserOrgUnitsMutation.mutateAsync({
                            deletedUserOrgUnitsIds: deletedUserOrgUnitsIdsManager,
                            addedUserOrgUnits: addedUserOrgUnitsManager
                        })];
                case 4:
                    _c.sent();
                    return [3 /*break*/, 6];
                case 5: return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
};
export var EditUserModal = function (_a) {
    var _b;
    var visible = _a.visible, onClose = _a.onClose, user = _a.user, refetch = _a.refetch, allOrgUnits = _a.allOrgUnits;
    var toast = useToast().toast;
    var updateUserRoleMutation = trpc.updateUser.useMutation();
    var updateUserOrgUnitsMutation = trpc.updateUserOrgUnit.useMutation();
    var _c = useState(user), userState = _c[0], setUserState = _c[1];
    useEffect(function () {
        setUserState(user);
    }, [user]);
    if (!userState)
        return null;
    var onSuccess = function () {
        toast({
            title: t('editUserModal.onSuccess', {
                name: userState.name
            }),
            variant: 'success',
            duration: 3000
        });
        refetch();
        onClose();
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (IS_DEMO) {
                        onSuccess();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, updateUserRole(user === null || user === void 0 ? void 0 : user.role, userState.role, userState.id, updateUserRoleMutation)];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, updateUserOrgUnits({
                            currentUserOrgUnits: (_a = user === null || user === void 0 ? void 0 : user.userOrgUnits) !== null && _a !== void 0 ? _a : [],
                            newUserOrgUnits: userState.userOrgUnits,
                            role: userState.role,
                            updateUserOrgUnitsMutation: updateUserOrgUnitsMutation
                        })];
                case 2:
                    _b.sent();
                    onSuccess();
                    return [2 /*return*/];
            }
        });
    }); };
    var roleOptions = [
        {
            id: UserRoles.USER,
            name: 'User'
        },
        {
            id: UserRoles.MANAGER,
            name: 'Manager'
        }
    ];
    return (_jsx(_Fragment, { children: _jsx(Modal, __assign({ visible: visible, onClose: onClose }, { children: _jsxs("div", __assign({ className: "w-11/12 flex flex-col items-center mx-auto" }, { children: [_jsx("p", __assign({ className: "text-gray-900 text-lg font-medium leading-7" }, { children: t('editUserModal.updateUser') })), _jsxs("div", __assign({ className: "shadow rounded-lg\tp-6 mt-5 w-full" }, { children: [_jsxs("div", __assign({ className: "flex flex-col gap-4 sm:flex-row sm:gap-0 sm:items-start" }, { children: [_jsxs("div", __assign({ className: "flex min-w-0 w-full sm:w-7/12 sm:pr-4" }, { children: [_jsx("div", __assign({ className: "mr-2 shrink-0" }, { children: _jsx(Avatar, { height: 40, width: 40, src: userState.avatar, text: userState.name || userState.email }) })), _jsxs("p", __assign({ className: "min-w-0 flex-1 text-sm leading-5" }, { children: [_jsxs("span", __assign({ className: "font-normal" }, { children: [userState.name, _jsx("span", __assign({ className: "ml-2 break-words font-normal text-gray-400" }, { children: userState.email }))] })), _jsx("br", {}), _jsx("span", __assign({ className: "font-normal text-gray-500" }, { children: userState.orgUnitNameWithParent }))] }))] })), _jsxs("div", __assign({ className: "min-w-0 w-full shrink-0 sm:w-5/12" }, { children: [_jsx("span", __assign({ className: "text-sm leading-5 font-normal text-gray-500" }, { children: _jsx(Select, { selected: (_b = roleOptions.find(function (r) { return r.id === userState.role; })) !== null && _b !== void 0 ? _b : roleOptions[0], options: roleOptions, onChange: function (option) {
                                                        return setUserState(__assign(__assign({}, userState), { role: option.id }));
                                                    }, disabled: userState.role === UserRoles.ADMIN }) })), _jsx("span", __assign({ className: "mt-3 text-sm leading-5 font-normal text-gray-500 sm:float-end " }, { children: _jsx(Link, __assign({ to: orgUnitsAndUsersHelpUrl, className: "text-gray-500 hover:text-blue-600", target: "_blank" }, { children: t('editUserModal.basicDescription') })) }))] }))] })), _jsx(EditOrgUnitsManager, { userState: userState, setUserState: setUserState, allOrgUnits: allOrgUnits })] })), _jsxs("div", __assign({ className: "flex self-end\tmt-5" }, { children: [_jsx(Button, __assign({ variant: "white", onClick: function () {
                                    onClose();
                                }, className: "mr-5" }, { children: t('button.cancel') })), _jsx(Button, __assign({ variant: "primary", onClick: handleSave }, { children: t('button.save') }))] }))] })) })) }));
};
export default EditUserModal;
